import { DatePicker as MuiDatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface DatePickerProps {
  className?: string;
  placeholder: string;
  value?: Date;
  minDate?: Date;
  maxDate?: Date;
  setValue: (date?: Date) => void;
  error?: boolean;
  disabled?: boolean;
}

const DatePicker: React.FC<DatePickerProps> = (props: DatePickerProps) => {
  const error = props.error ? "Mui-error" : "";

  const handleDateChange = (date: MaterialUiPickersDate) => {
    props.setValue(date?.toDate());
  };

  return (
    <MuiDatePicker
      className={`${props.className} ${error}`}
      value={props.value ? props.value : null}
      label={props.placeholder}
      onChange={(date) => handleDateChange(date)}
      format="DD/MM/YYYY"
      minDate={props.minDate}
      maxDate={props.maxDate}
      // clearable
      disabled={props.disabled}
      okLabel="OK"
      // clearLabel="LIMPIAR"
      cancelLabel="CANCELAR"
      variant="dialog"
      inputVariant="outlined"
    />
  );
};

export default DatePicker;
